<template>
    <div>
        <div class="loader" v-show="showLoading"></div>
        <div v-show="!showLoading">

            <!-- documents grid -->
            <div class="loader" v-show="loading"></div>
            <div class="grid-wrapper" v-show="!loading">
                <kendo-datasource ref="datasource"
                                  :transport="transportSettings"
                                  :schema-model-id="'documentId'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'count'"
                                  :schema-data="'items'"
                                  :page-size="5"
                                  :server-paging="false"
                                  :server-sorting="false"
                                  :server-filtering="false"
                                  :change="onChange"></kendo-datasource>
                <kendo-grid ref="docsGrid"
                            :data-source-ref="'datasource'"
                            :sortable="true"
                            :filterable="true"
                            :dataBound="onDatabound"
                            :pageable="true"
                            :resizable="true"
                            name="docsGrid">
                    <kendo-grid-column :title="$t('eventDocuments.eventDocsGrid.actions')"
                                        field="btnsColumn"
                                       :width="120"
                                       :lockable="false"
                                       :locked="false"
                                       :filterable="false"
                                       :sortable="false"
                                       :template="btnsTemplate"></kendo-grid-column>
                    <kendo-grid-column :field="'registerEntityId'" :title="$t('eventDocuments.eventDocsGrid.registerEntityId')" :width="150" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'eventName'" :title="$t('eventDocuments.eventDocsGrid.eventName')" :width="300" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'fileName'" :title="$t('eventDocuments.eventDocsGrid.fileName')" :width="300" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'documentId'" :title="$t('eventDocuments.eventDocsGrid.documentId')" :width="100" :lockable="true" :locked="false"></kendo-grid-column>
                    <!--<kendo-grid-column :field="'docType'" :title="$t('eventDocuments.eventDocsGrid.docType')" :width="70" :lockable="true" :locked="false"></kendo-grid-column>-->
                    <kendo-grid-column :field="'createdOn'"
                                       :title="$t('eventDocuments.eventDocsGrid.createdOn')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :format="customDateTimeFormat"></kendo-grid-column>
                    <kendo-grid-column :field="'userShortFullName'" :title="$t('eventDocuments.eventDocsGrid.createdBy')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'eventStartDate'"
                                       :title="$t('eventDocuments.eventDocsGrid.eventStartDate')"
                                       :width="190"
                                       :lockable="true"
                                       :locked="false"
                                       :format="customDateTimeFormat"></kendo-grid-column>
                    <kendo-grid-column :field="'eventEndDate'"
                                       :title="$t('eventDocuments.eventDocsGrid.eventEndDate')"
                                       :width="170"
                                       :lockable="true"
                                       :locked="false"
                                       :format="customDateTimeFormat"></kendo-grid-column>
                    <kendo-grid-column :field="'eventLocation'" :title="$t('eventDocuments.eventDocsGrid.eventLocation')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'eventMainActivity'" :title="$t('eventDocuments.eventDocsGrid.eventMainActivity')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'eventActivityDirection'" :title="$t('eventDocuments.eventDocsGrid.eventActivityDirection')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'eventDirectorate'" :title="$t('eventDocuments.eventDocsGrid.eventDirectorate')" :width="380" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'eventProjectName'" :title="$t('eventDocuments.eventDocsGrid.eventProjectName')" :width="400" :lockable="true" :locked="false"></kendo-grid-column>

                    <kendo-grid-column :field="'eventCode'" :title="$t('eventDocuments.eventDocsGrid.eventCode')" :width="150" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'eventSubscriptionStartDate'"
                                       :title="$t('eventDocuments.eventDocsGrid.eventSubscriptionStartDate')"
                                       :width="170"
                                       :lockable="true"
                                       :locked="false"
                                       :format="customDateTimeFormat"></kendo-grid-column>
                    <kendo-grid-column :field="'eventSubscriptionEndDate'"
                                       :title="$t('eventDocuments.eventDocsGrid.eventSubscriptionEndDate')"
                                       :width="170"
                                       :lockable="true"
                                       :locked="false"
                                       :format="customDateTimeFormat"></kendo-grid-column>
                    <kendo-grid-column :field="'eventStatus'" :title="$t('eventDocuments.eventDocsGrid.eventStatus')" :width="150" :lockable="true" :locked="false" :hidden="isEnVersion"></kendo-grid-column>
                    <kendo-grid-column :field="'eventStatusEn'" :title="$t('eventDocuments.eventDocsGrid.eventStatus')" :width="150" :lockable="true" :locked="false" :hidden="!isEnVersion"></kendo-grid-column>
                    <kendo-grid-column :field="'eventForm'" :title="$t('eventDocuments.eventDocsGrid.eventForm')" :width="150" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'eventSort'" :title="$t('eventDocuments.eventDocsGrid.eventSort')" :width="150" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'eventVenue'" :title="$t('eventDocuments.eventDocsGrid.eventVenue')" :width="250" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'eventOrganizerName'" :title="$t('eventDocuments.eventDocsGrid.eventOrganizerName')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'eventLegalArea'" :title="$t('eventDocuments.eventDocsGrid.eventLegalArea')" :width="300" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'eventFundingType'" :title="$t('eventDocuments.eventDocsGrid.eventFundingType')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'eventNote'" :title="$t('eventDocuments.eventDocsGrid.eventNote')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'thematicArea'" :title="$t('eventDocuments.eventDocsGrid.thematicArea')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'theme'" :title="$t('eventDocuments.eventDocsGrid.theme')" :width="200" :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'eventMoodleCategory'" :title="$t('eventDocuments.eventDocsGrid.eventMoodleCategory')" :width="150" :lockable="true" :locked="false"></kendo-grid-column>

                </kendo-grid>
            </div>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters } from 'vuex';
    import BtnsTemplate from '../../components/grid/StandardBtnsTemplate';

    export default {
        props: {
            lecturerId: {
                type: [Number],
                required: false,
                default: 0
            },
            participantId: {
                type: [Number],
                required: false,
                default: 0
            }
        },
        components: {
        },
        data() {
            return {
                showLoading: false,
                schemaModelFields: {
                    registerEntityId: { name: 'registerEntityId', type: 'int', editable: false, nullable: true, visible: true },
                    eventName: { name: 'eventName', type: 'string', editable: false, nullable: true, visible: true },
                    fileName: { name: 'fileName', type: 'string', editable: false, nullable: true, visible: true },
                    documentId: { name: 'documentId', type: 'number', editable: false, nullable: true, visible: true },
                    createdOn: { name: 'createdOn', type: 'date', editable: false, nullable: true, visible: true },
                    userShortFullName: { name: 'userShortFullName', type: 'string', editable: false, nullable: true, visible: true },
                    eventStartDate: { name: 'eventStartDate', type: 'date', editable: false, nullable: true, visible: true },
                    eventEndDate: { name: 'eventEndDate', type: 'date', editable: false, nullable: true, visible: true },
                    eventLocation: { name: 'eventLocation', type: 'string', editable: false, nullable: true, visible: true },
                    eventMainActivity: { name: 'eventMainActivity', type: 'string', editable: false, nullable: true, visible: true },
                    eventActivityDirection: { name: 'eventActivityDirection', type: 'string', editable: false, nullable: true, visible: true },
                    eventDirectorate: { name: 'eventDirectorate', type: 'string', editable: false, nullable: true, visible: true },
                    eventProjectName: { name: 'eventProjectName', type: 'string', editable: false, nullable: true, visible: true },

                    eventCode: { name: 'eventCode', type: 'string', editable: false, nullable: true, visible: true },
                    eventSubscriptionStartDate: { name: 'eventSubscriptionStartDate', type: 'date', editable: false, nullable: true, visible: true },
                    eventSubscriptionEndDate: { name: 'eventSubscriptionEndDate', type: 'date', editable: false, nullable: true, visible: true },
                    eventStatus: { name: 'eventStatus', type: 'string', editable: false, nullable: true, visible: true },
                    eventStatusEn: { name: 'eventStatusEn', type: 'string', editable: false, nullable: true, visible: true },
                    eventForm: { name: 'eventForm', type: 'string', editable: false, nullable: true, visible: true },
                    eventSort: { name: 'eventSort', type: 'string', editable: false, nullable: true, visible: true },
                    eventVenue: { name: 'eventVenue', type: 'string', editable: false, nullable: true, visible: true },
                    eventOrganizerName: { name: 'eventOrganizerName', type: 'string', editable: false, nullable: true, visible: true },
                    eventLegalArea: { name: 'eventLegalArea', type: 'string', editable: false, nullable: true, visible: true },
                    eventFundingType: { name: 'eventFundingType', type: 'string', editable: false, nullable: true, visible: true },
                    eventNote: { name: 'eventNote', type: 'string', editable: false, nullable: true, visible: true },
                    thematicArea: { name: 'thematicArea', type: 'string', editable: false, nullable: true, visible: true },
                    theme: { name: 'theme', type: 'string', editable: false, nullable: true, visible: true },
                    eventMoodleCategory: { name: 'eventMoodleCategory', type: 'string', editable: false, nullable: true, visible: true },
                },
                transportSettings: {
                    read: {
                        url: this.getURL,
                        dataType: 'json',
                        type: 'GET',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    }
                },
                files: [],
                loading: false,
            };
        },
        methods: {
            onDatabound(e) { },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        btns: [
                            {
                                name: 'download',
                                text: '',
                                tooltip: this.$t('buttons.download.tooltipText'),
                                class: 'btn btn-success',
                                icon: 'fas fa-download',
                                show: true,
                                clickHandler: this.downloadDoc
                            },
                            {
                                name: 'details',
                                text: '',
                                tooltip: this.$t('eventDocuments.eventDocsGrid.openEvent'),
                                class: 'btn btn-info',
                                icon: 'fas fa-info-circle',
                                show: e.registerEntityId,
                                clickHandler: this.navigateToEventEdit
                            }
                        ]
                    }
                };
            },
            onChange(data) {
                data.items.forEach(item => {
                    item.createdOn = this.$helpers.convertFromUtcToLocal(item.createdOn);
                    item.eventStartDate = this.$helpers.convertFromUtcToLocal(item.eventStartDate);
                    item.eventEndDate = this.$helpers.convertFromUtcToLocal(item.eventEndDate);
                });
            },
            downloadDoc(e) {
                const downloadUri = this.$store.getters.baseUrl + `/api/file/download/?id=${e.id}&type=${e.docTypeCode}&hash=${e.hash}`;
                this.loading = true;
                this.$http.get(downloadUri, { responseType: 'blob' })
                    .then(response => {
                        const blob = new Blob([response.data]);
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', e.fileName); // or any other extension
                        document.body.appendChild(link);
                        link.click();
                        window.URL.revokeObjectURL(url);
                    })
                    .catch(err => {
                        this.$vs.notify({
                            color: 'danger',
                            title: this.$t('notifications.error'),
                            text: this.$helpers.errorText(err)
                        })
                    })
                    .then(() => { this.loading = false; });
            },
            navigateToEventEdit(e) {
                let routeData = this.$router.resolve({ name: 'eventsEdit', params: { id: e.registerEntityId } });
                window.open(routeData.href, '_blank');
            },
            refresh() {
                this.$refs['docsGrid'].kendoWidget().dataSource.read();
            },
            getURL() {
                const id = (this.lecturerId && this.lecturerId > 0) ? this.lecturerId : this.participantId;
                const suffix = (this.lecturerId && this.lecturerId > 0) ? 'lecturerDocs' : 'participantDocs';
                return `${this.$store.getters.baseUrl}/api/documentsRelation/${id}/${suffix}`;
            }
        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            ...mapGetters(['claims', 'userId', 'dateTimeFormat', 'isEnVersion']),
            customDateTimeFormat() {
                return `{0:${this.dateTimeFormat}}`
            }
        },
        mounted() { },
        watch: {
            participantId: function (val) {
                if (val) {
                    this.participantId = val;
                    this.lecturerId = null;
                    this.refresh();
                }
            },
            lecturerId: function (val) {
                if (val) {
                    this.lecturerId = val;
                    this.participantId = null;
                    this.refresh();
                }
            }
        }
    };
</script>

<style lang="scss">
    .grid-wrapper {
        overflow-x: auto;
    }

    .k-grid td {
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>
